var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',[(_vm.$route.fullPath != '/login')?_c('SideBar'):_vm._e(),_c('div',{class:[_vm.$route.fullPath != '/login' ? 'router-wrapper' : null , _vm.$vuetify.rtl ? 'rtl' : null]},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }